import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { freeNotificatins } from "store/actions";
import { me, UPDATE_NOTIFICATION_INTERVAL } from "constants/Client";
import { ROLES } from "common/ComponentAccess";
import { showNotifications } from "common/ApiCalls";

const NotificationDropdown = props => {
  const dispatch = useDispatch();
  const [menu, setMenu] = useState(false);
  const [notificationsList, setNotificationsList] = useState([]);

  const { notifications } = useSelector(state => ({
    notifications: state.Profile.notifications,
  }));

  const getNotList = () => {
    if (me().role === ROLES.STAFF) return;
    let intervalId = "";
    showNotifications(dispatch);
    intervalId = setInterval(() => {
      if (me().role === ROLES.STAFF) clearInterval(intervalId);
      showNotifications(dispatch);
    }, UPDATE_NOTIFICATION_INTERVAL);
  };

  useEffect(() => {
    setNotificationsList(notifications ? notifications : []);
  }, [notifications]);

  useEffect(() => {
    getNotList();
  }, []);

  const releaseNotifications = () => {
    dispatch(freeNotificatins({ client_id: me().uid }, dispatch));
  };

  return (
    <React.Fragment>
      <Dropdown isOpen={menu} toggle={() => setMenu(!menu)} className='dropdown d-inline-block' tag='li' onClick={() => releaseNotifications()}>
        <DropdownToggle className='btn header-item noti-icon' tag='button' id='page-header-notifications-dropdown'>
          <i className={`bx bx-bell ${notificationsList?.notification ? "bx-tada" : ""}`} />
          <span className='badge bg-danger rounded-pill'>{notificationsList?.notification ? notificationsList?.body?.length : ""}</span>
        </DropdownToggle>

        <DropdownMenu className='dropdown-menu dropdown-menu-lg dropdown-menu-end p-0'>
          <div className='p-3'>
            <Row className='align-items-center'>
              <Col>
                <div className='m-0 h6'> {props.t("Notifications")} </div>
              </Col>
            </Row>
          </div>

          <SimpleBar style={{ height: "230px" }}>
            {notificationsList?.body?.length ? (
              notificationsList?.body?.map((item, key) => (
                <Link to={item.type === "email" ? "email-inbox" : ""} key={key} className='text-reset notification-item'>
                  <div className='d-flex'>
                    <div className='avatar-xs me-3'>
                      <span className='avatar-title bg-primary rounded-circle font-size-16'>{item?.type?.charAt(0)?.toUpperCase()}</span>
                    </div>
                    <div className='flex-grow-1'>
                      <div className='mt-0 mb-1 text-capitalize h6'>{props.t(item.type)}</div>
                      <div className='font-size-12 text-muted'>
                        <div className='mb-1'>{props.t(item.message)}</div>
                        {/* <div className="mb-0">
                        <i className="mdi mdi-clock-outline" />{" "}
                        {props.t("3 min ago")}{" "}
                      </div> */}
                      </div>
                    </div>
                  </div>
                </Link>
              ))
            ) : (
              <div className='text-center text-muted font-size-12'>No Notification</div>
            )}
          </SimpleBar>
          {/* <div className="p-2 border-top d-grid">
            <Link className="btn btn-sm btn-link font-size-14 text-center" to="#">
              <i className="mdi mdi-arrow-right-circle me-1"></i> <span key="t-view-more">{props.t("View More..")}</span>
            </Link>
          </div> */}
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withTranslation()(NotificationDropdown);

NotificationDropdown.propTypes = {
  t: PropTypes.any,
};
